export default __webpack_public_path__ + "static/media/Slide6.fb4b44b7.PNG";